<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <transition name="fade">
          <div class="wrapper" v-if="!isLoading && currentPage">
            <div class="title">{{ currentPage.title }}</div>
            <div class="desc" v-html="currentPage.header"></div>
            <div class="desc" v-html="currentPage.content"></div>
          </div>
          <div class="wrapper" v-else-if="isLoading">Loading...</div>
        </transition>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "TextPage",

  computed: {
    ...mapState("staticPages", ["currentPage", "isLoading", "error"]),
  },

  async created() {
    await this.loadInitialData();
  },

  watch: {
    "$route.params.identifier": {
      handler: "loadPageData",
      immediate: true,
    },
  },

  methods: {
    ...mapActions("staticPages", ["fetchPages", "fetchPageContent"]),
    async loadInitialData() {
      try {
        await this.fetchPages();
        await this.loadPageData();
      } catch (error) {
        this.handleError(error);
      }
    },

    async loadPageData() {
      try {
        const identifier = this.$route.params.identifier;
        if (identifier) {
          await this.fetchPageContent(identifier);
        } else {
          this.redirectTo404();
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    handleError(error) {
      if (error.response && error.response.status === 404) {
        this.redirectTo404();
      } else {
        console.error(error);
      }
    },

    redirectTo404() {
      this.$router.push({ name: "PageNotFound" });
    },
  },
};
</script>
